export class ListZeroEtlTargetTablesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<ZeroEtlTargetTable>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlTargetTablesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
